export default __webpack_public_path__ + "static/logo-052020af8399fa513fed1f93969114f3.png";